import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Usuario } from 'src/app/model/index.model';
import { ContenedorRegLogComponent } from 'src/app/pages/user/componentes/custom/contenedor-reg-log/contenedor-reg-log.component';
import { MercaderiaService, WorkshoppingService } from 'src/app/service/index.service';
import { UturuncoUtils } from 'src/app/utils/uturuncoUtils';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss'],
  providers: [WorkshoppingService]
})
export class ProductDetailComponent implements OnInit {

  product: any;
  loading = true;
  usuario: Usuario

  url: string = environment.configUrl;
  conf: any

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private wsdl: MercaderiaService,
    private wsdlwk: WorkshoppingService,
    private modalService: NgbModal,
  ) {
    this.usuario = new Usuario()
    this.usuario = JSON.parse(UturuncoUtils.getSession(UturuncoUtils.UC))

  }

  async ngOnInit() {
    await this.wsdlwk.registrarCliente();
    await this.wsdlwk.cargarCarrito();

    const id = this.route.snapshot.paramMap.get('id');
    try {
      if (id) {
        const data = await this.wsdl.doFind(id).then();
        this.product = data.data;
        if (!this.product.mostrar) {
          UturuncoUtils.showToas("No contamos con ese producto", 'info')
          this.inicio()
        }
      }
      this.http.get(this.url).subscribe(res => {
        this.conf = res;
      });
    } catch (error) {

    } finally {
      this.loading = false;
    }

  }
  async addToCart() {
    this.wsdlwk.cantidad = 1
    await this.wsdlwk.itemSel(this.product)
  }

  inicio() {
    this.router.navigate(['/'])
  }
  comprarAhora() {
    // agregar al carrito y redirigir a checkout
    this.addToCart();
    this.openModalLogin()
  }


  openModalLogin() {
    if (this.usuario) {
      this.router.navigate(["/user/dashboard/perfil"])
      return
    }

    const modalRef = this.modalService.open(ContenedorRegLogComponent, {
      size: 'md',
      centered: true,
      keyboard: true       // permite cerrar con ESC
    });

    //modalRef.componentInstance.product = product;

    modalRef.result.then(
      result => {
        this.usuario = JSON.parse(UturuncoUtils.getSession(UturuncoUtils.UC))
        console.log('Modal cerrado con:', result);
      },
      reason => {
        console.log('Modal descartado con:', reason);
      }
    );
  }

  shareProduct() {
    const url = window.location.href;
    const title = this.product?.nombre || 'Producto';
    const text = `Mirá este producto: ${this.product?.nombre} - $${this.product?.precio}`;

    if (navigator.share) {
      navigator.share({ title, text, url })
        .catch(err => console.error('Error al compartir:', err));
    } else {
      navigator.clipboard.writeText(url).then(() => {
        alert('Link copiado al portapapeles');
      });
    }
  }

  get descripcionConSaltos(): string {
    if (!this.product?.descripcion) return '';
    return this.product.descripcion.replace(/\n/g, '<br>');
  }
}
